import React, { forwardRef, useState } from "react";

import { Select } from "../../../components";
import useSelectTheme from "../../../hooks/useSelectTheme";
import { useUserSearchSelect } from "../../hooks/useUserSearchSelect";

type UserOption = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  fullName: string;
  email: string;
  profilePicUrl?: string | null;
};

const formatOption = (
  user: UserOption
): { label: string; value: UserOption } => ({
  label: `${user.fullName} - ${user.email}`,
  value: user,
});

type InterviewerSelectProps = {
  onChange: (interviewers: UserOption[]) => void;
  defaultInterviewers?: UserOption[];
  isDisabled?: boolean;
  onBlur: any;
  autoFocus?: boolean;
};

const InterviewerSelect = forwardRef<any, InterviewerSelectProps>(
  (
    { onChange, defaultInterviewers = [], isDisabled = false, ...rest },
    ref
  ) => {
    const [theme, styles] = useSelectTheme();
    const [selectedInterviewers, setSelectedInterviewers] =
      useState<UserOption[]>(defaultInterviewers);
    const { users, loading, onInputChange } = useUserSearchSelect();
    const isSelectable = selectedInterviewers?.length < 10;

    return (
      <Select
        isDisabled={isDisabled}
        ref={ref}
        data-testid="interviewers-select"
        theme={theme}
        styles={styles}
        isClearable
        isMulti
        menuShouldBlockScroll
        menuShouldScrollIntoView
        menuPlacement="top"
        placeholder="Enter email or name"
        isLoading={loading}
        filterOption={() => true}
        value={selectedInterviewers.map(formatOption)}
        options={isSelectable ? users.map(formatOption) : []}
        onInputChange={onInputChange}
        onChange={(selectedOptions) => {
          if (!selectedOptions) {
            setSelectedInterviewers([]);
            onChange([]);
            return;
          }
          const values = selectedOptions.map((o) => o.value);
          setSelectedInterviewers(values);
          onChange(values);
        }}
        menuPortalTarget={document.getElementById("root")}
        {...rest}
      />
    );
  }
);

InterviewerSelect.displayName = "InterviewerSelect";
export default InterviewerSelect;
